// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  SimulationScenario,
  SimulationScenarioT,
  verifySimulationScenario,
} from "./simulation-scenario";

export class SimulationScenarioList implements flatbuffers.IUnpackableObject<SimulationScenarioListT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationScenarioList {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationScenarioList(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationScenarioList,
  ): SimulationScenarioList {
    return (obj || new SimulationScenarioList()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSimulationScenarioList(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationScenarioList,
  ): SimulationScenarioList {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationScenarioList()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  scenarios(index: number, obj?: SimulationScenario): SimulationScenario | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new SimulationScenario()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  scenariosLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startSimulationScenarioList(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addScenarios(builder: flatbuffers.Builder, scenariosOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, scenariosOffset, 0);
  }

  static createScenariosVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startScenariosVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endSimulationScenarioList(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createSimulationScenarioList(
    builder: flatbuffers.Builder,
    scenariosOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    SimulationScenarioList.startSimulationScenarioList(builder);
    SimulationScenarioList.addScenarios(builder, scenariosOffset);
    return SimulationScenarioList.endSimulationScenarioList(builder);
  }

  unpack(): SimulationScenarioListT {
    return new SimulationScenarioListT(
      this.bb!.createObjList<SimulationScenario, SimulationScenarioT>(
        this.scenarios.bind(this),
        this.scenariosLength(),
      ),
    );
  }

  unpackTo(_o: SimulationScenarioListT): void {
    _o.scenarios = this.bb!.createObjList<SimulationScenario, SimulationScenarioT>(
      this.scenarios.bind(this),
      this.scenariosLength(),
    );
  }

  unpackFields(...fields: string[]): SimulationScenarioListT {
    const t = new SimulationScenarioListT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("scenarios")) {
      t.scenarios = this.bb!.createObjList<SimulationScenario, SimulationScenarioT>(
        this.scenarios.bind(this),
        this.scenariosLength(),
      );
    }
    return t;
  }
}

export class SimulationScenarioListT implements flatbuffers.IGeneratedObject {
  constructor(public scenarios: SimulationScenarioT[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const scenarios = SimulationScenarioList.createScenariosVector(
      builder,
      builder.createObjectOffsetList(this.scenarios),
    );

    return SimulationScenarioList.createSimulationScenarioList(builder, scenarios);
  }

  clone(): SimulationScenarioListT {
    const obj = new SimulationScenarioListT();
    obj.scenarios = this.scenarios.map((e) => e.clone());
    return obj;
  }

  equals(other: SimulationScenarioListT): boolean {
    if (this.scenarios.length !== other.scenarios.length) return false;
    for (let i = 0; i < this.scenarios.length; i++) {
      const a = this.scenarios[i];
      const b = other.scenarios[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifySimulationScenarioList(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifySimulationScenario);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
